export const setFilterTagsActionType = 'setFilterTagsActionType';

export function setFilterTagsAction(tags) {
    return {
        type: setFilterTagsActionType,
        payload: {
            tags: tags,
        }
    }
}

export function setFilterTagsHandler(state, action) {
    const { tags } = action.payload;
    return {...state, filterTags: tags, directoryContentTargetItemIndexes: new Map(), predictedSelectedFileSystemNodeType: 'directory', selectedFileSystemNodePath: []};
}
